import CSVPreviewSection from '../CSVPreviewSection'
import {ReportGroupingLevel} from '../../../constants'

export default function StaffPerformanceCSVPreviewGroupingSection() {}

StaffPerformanceCSVPreviewGroupingSection.prototype = new CSVPreviewSection();
StaffPerformanceCSVPreviewGroupingSection.prototype.init = function ( firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, columnsStrategy, numOfGroupingRows )
{
    CSVPreviewSection.prototype.init.call( this );
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.columnsStrategy = columnsStrategy;
    this.numOfGroupingCols = numOfGroupingRows;
    return this;
};

StaffPerformanceCSVPreviewGroupingSection.prototype.addRows = function ( tBody )
{
    const emptyRow = this.createRow()
    ReportPreviewUtils.addEmptyCell( emptyRow );

    let totalsRow = this.createRow();
    this.addCellWithFloatingContent( totalsRow, this.message("report.staffoutput.total_working_time") );

    for( let i = 0; i < this.numOfGroupingCols; i++ )
    {
        let row = this.createRow()
        this.addCell( row, ReportPreviewUtils.getLevelPreviewName( this.firstGroupingLevel ) );
        if( this.secondGroupingLevel !== ReportGroupingLevel.NONE )
            this.addCell( row, ReportPreviewUtils.getLevelPreviewName( this.secondGroupingLevel ) );
        if( this.thirdGroupingLevel !== ReportGroupingLevel.NONE )
            this.addCell( row, ReportPreviewUtils.getLevelPreviewName( this.thirdGroupingLevel ) );
        this.columnsStrategy.addDataCells( row );
        this.addRow( tBody, row );
    }

    if( this.secondGroupingLevel !== ReportGroupingLevel.NONE )
    {
        ReportPreviewUtils.addEmptyCell( emptyRow );
        ReportPreviewUtils.addEmptyCell( totalsRow );
    }

    if( this.thirdGroupingLevel !== ReportGroupingLevel.NONE )
    {
        ReportPreviewUtils.addEmptyCell( emptyRow );
        ReportPreviewUtils.addEmptyCell( totalsRow );
    }

    this.columnsStrategy.addEmptyCells( emptyRow );
    this.addRow( tBody, emptyRow );

    this.columnsStrategy.addDataCells( totalsRow );
    this.addRow( tBody, totalsRow );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/staffperformance/StaffPerformanceCSVPreviewGroupingSection.js